/**
 * Filters an array of objects based on the existence of specified keys.
 *
 * @param objects - The array of objects to filter.
 * @param keys - The keys to check for existence in each object.
 * @returns An array of objects that have all the specified keys.
 */
export const filterObjectsByExistingKeys = <T>(
  objects: T[],
  keys: (keyof T)[]
) => {
  return objects.filter((object) => {
    return keys.every((key) => object[key])
  })
}
